export const FieldError = ({ message }: { message?: string | undefined }) =>
  message ? <small className="field-error" role="alert">{message}</small> : null;
